export enum ErrorIdEnumeration {
  BUTTON = 'BUTTON',
  DESCRIPTION = 'DESCRIPTION',
  TITLE = 'TITLE',
}
